<div #pageContainer class="w-full">
    <form [formGroup]="searchForm">
        <div class="grid grid-cols-2 gap-2">
            <div class="flex justify-start">
                <div class="w-19 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <button
                    class="btn btn-outline btn-default dt-download mx-2 group"
                    [matMenuTriggerFor]="downloadMenu"
                >
                    <mat-icon
                        class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-down-tray"
                    ></mat-icon>
                </button>
                <mat-menu #downloadMenu="matMenu">
                    <button mat-menu-item (click)="downloadStringsSummaryExcel()">
                        <span>Excel</span>
                    </button>
                </mat-menu>
            </div>
            <div class="flex justify-end">
                <app-single-filter
                    [searchForm]="searchForm"
                    [filterBy]="'String'"
                    class="text-primary w-64"
                ></app-single-filter>

                <button
                    class="btn btn-primary mx-2"
                    (click)="setPage({ offset: 0 })"
                >
                    Search
                </button>
                <button class="btn btn-outline btn-default" (click)="reset()">
                    Reset
                </button>
                <button
                    class="btn btn-outline btn-default mx-2 group"
                    (click)="setPage({ offset: dt.page.offset })"
                >
                    <mat-icon
                        class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-path"
                    ></mat-icon>
                </button>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div
            class="table-cm-string-summary-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort
            matSortDisableClear
        >
            <div class="border py-8 text-center">No</div>

            <div
                [mat-sort-header]="'fieldLongName'"
                class="flex justify-center border py-8"
            >
                Field
            </div>

            <div
                [mat-sort-header]="'platformLongName'"
                class="flex justify-center border py-4"
            >
                Platform
            </div>

            <div
                [mat-sort-header]="'wellLongName'"
                class="flex justify-center border py-4"
            >
                Well
            </div>

            <div
                [mat-sort-header]="'stringLongName'"
                class="flex justify-center border py-4"
            >
                Well String
            </div>

            <div
                [mat-sort-header]="'stringIndicatorShortName'"
                class="flex justify-center border py-4"
            >
                String Indicator
            </div>

            <div
                [mat-sort-header]="'source'"
                class="flex justify-center border py-4"
            >
                Source
            </div>

            <div
                [mat-sort-header]="'failureDate'"
                class="flex justify-center border py-4"
            >
                Failure Date
            </div>

            <div
                [mat-sort-header]="'failEquipment'"
                class="flex justify-center border py-4"
            >
                Failure Equipment
            </div>

            <div
                [mat-sort-header]="'problemReported'"
                class="flex justify-center border py-4"
            >
                Problem Reported
            </div>

            <div
                [mat-sort-header]="'forwardActionPlan'"
                class="flex justify-center border py-4"
            >
                Forward Action Plan
            </div>

            <div
                [mat-sort-header]="'detailDesc'"
                class="flex justify-center border py-4"
            >
                Detail Description
            </div>

            <div
                [mat-sort-header]="'rectifiedDate'"
                class="flex justify-center border py-4"
            >
                Date Rectified
            </div>

            <div
                [mat-sort-header]="'status'"
                class="flex justify-center border py-4"
            >
                Status
            </div>

            <div
                [mat-sort-header]="'wellProductionStatus'"
                class="flex justify-center border py-4"
            >
                Well Status
            </div>

            <div
                [mat-sort-header]="'category'"
                class="flex justify-center border py-4"
            >
                Category
            </div>

            <div
                [mat-sort-header]="'equipment'"
                class="flex justify-center border py-4"
            >
                Equipment
            </div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container
                *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;"
            >
                <div
                    class="table-cm-string-summary-grid grid items-center border-b"
                    [ngClass]="{'bg-primary-100': i % 2 }"
                >
                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldLongName }}
                    </div>

                    <!-- Platform Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.platformLongName }}
                    </div>

                    <!-- Well Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.wellLongName }}
                    </div>

                    <!-- Well String Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.stringLongName }}
                    </div>

                    <!-- String Indicator -->
                    <div class="flex truncate justify-center">
                        {{ row.stringIndicatorShortName }}
                    </div>

                    <!-- Source -->
                    <div class="flex truncate justify-center">
                        {{ row.source }}
                    </div>

                    <!-- Failure Date -->
                    <div class="flex truncate justify-center">
                        {{ handleFormatDate(row.failureDate,false) }}
                    </div>

                    <!-- Fail Equipment -->
                    <div class="flex truncate justify-center">
                        {{ row.failEquipment || '-' }}
                    </div>

                    <!-- Problem Reported -->
                    <div
                        class="flex justify-center whitespace-normal break-words"
                    >
                        {{ row.problemReported || '-' }}
                    </div>

                    <!-- Forward Action Plan -->
                    <div
                        class="flex justify-center whitespace-normal break-words"
                    >
                        {{ row.forwardActionPlan || '-' }}
                    </div>

                    <!-- Detail desc -->
                    <div class="flex truncate justify-center">
                        {{ row.detailDesc || '-' }}
                    </div>

                    <!-- Rectified Date -->
                    <div class="flex truncate justify-center">
                        {{ handleFormatDate(row.rectifiedDate,false) }}
                    </div>

                    <!-- Status -->
                    <div class="flex truncate justify-center">
                        {{ row.status }}
                    </div>

                    <!-- Well Status -->
                    <div class="flex truncate justify-center">
                        {{ row.wellProductionStatus }}
                    </div>

                    <!-- Category -->
                    <div class="flex truncate justify-center">
                        {{ row.category }}
                    </div>

                    <!-- Equipment -->
                    <div class="flex truncate justify-center">
                        {{ row.equipment || '-' }}
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div
                class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center"
            >
                There are no Records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
    >
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ?
            'total' : 'totals' }}
        </div>

        <mat-paginator
            class="bg-gray-50"
            [ngClass]="{'pointer-events-none': isLoading}"
            [length]="dt.page?.totalRecords"
            [pageIndex]="dt.page.offset"
            [pageSize]="dt.page.size"
            [hidePageSize]="true"
            [showFirstLastButtons]="true"
        >
        </mat-paginator>
    </div>
</div>
